/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, reduce, replace } from 'lodash-es'

import * as en from '../../assets/translations/en.json'
import * as ro from '../../assets/translations/ro.json'
import { TranslationKey } from '../../types/global'
import { EN, RO } from '../constants'

const translations: any = {
  [EN]: en,
  [RO]: ro,
}

const getTranslation = (
  lng: string,
  translationKey: TranslationKey,
): string => {
  return get(translations[lng], translationKey, translationKey)
}

const interpolate = (translation: string, map: any) =>
  reduce(
    map,
    (interpolatedTranslation, value, key) =>
      replace(interpolatedTranslation, `{{${key}}}`, value),
    translation,
  )

const translate = (lng: string, translationKey: TranslationKey, map?: any) =>
  map
    ? interpolate(getTranslation(lng, translationKey), map)
    : getTranslation(lng, translationKey)

export default translate
